import BaseInfoType from '@/model/baseInfo'
import MoreInfoType from '@/model/moreInfo'
import { getAppType, getSysType } from '@utils/ua'
import Fetch from '../../request'
const host = 'https://app.zhuanzhuan.com'
const API = {
  goodsInfo: `${host}/zzopen/waresshow/baseInfo`, //商品基本信息
  goodsRedPack: `${host}/zzopen/hypermall/receiveCoupon`, //领红包接口
  goodsMoreInfo: `${host}/zzopen/waresshow/moreInfo`, //更多信息, 包括质检报告信息等
  delLoveInfo: `${host}/zz/transfer/delLoveInfo`, //删除收藏
  addLoveInfo: `${host}/zz/transfer/addLoveInfo`, //加入收藏
  addIntoCartFromInfoDetail: `${host}/zz/transfer/addIntoCartFromInfoDetail`, //加入购物车
  goodsList: `${host}/zzopen/ypmall/listData`, //商品推荐列表接口
  widget: `${host}/zzopen/ypmall/widget`, // 获取挂价信息
  similarProducts: `${host}/zzopen/ypmall/sameStyleRec`, // 获取同款推荐
  sameModelEvaluateStatistics: `${host}/zzopen/b2cmall_evea/sameModelEvaluateStatistics`, // $ 查询商品同款评价统计信息
  orderEvaluatePage: `${host}/zzopen/b2cmall_evea/orderEvaluatePage`, // $ 分页查询评价列表
  getQcHelpfulCount: `${host}/zzopen/hypermall/getQcHelpfulCount`, // $ 获取帮助信息
  incrQcHelpfulCount: `${host}/zzopen/hypermall/incrQcHelpfulCount`, // $ 增加有帮助数值
  getQcItemFeedbackInfo: `${host}/zzopen/hypermall/getQcItemFeedbackInfo`, // $ 获取质检项的反馈项信息
  submitQcItemFeedback: `${host}/zzopen/hypermall/submitQcItemFeedback`, // $ 提交质检项反馈
  zcShowList: `${host}/zzopen/b2cmall_evea/zcShowList`, // $ 转转卖场 获取种草秀数据
  getCostPerformanceUserGiveUpVo: `${host}/zzopen/waresshow/getCostPerformanceUserGiveUpVo`, // $ 转转卖场 商详点击立即购买或者以旧换新拉起半弹窗
  touchInfo: `${host}/zzopen/b2cmall_msgcenter/touchInfo`,
  touchInfoByOcd: `${host}/zzopen/b2cmall_msgcenter/touchInfoByOcd`,
  transmitParamSearch: `${host}/zzopen/b2cmall_msgcenter/transmitParamSearch`,
  getModelExplainBaseData: `${host}/zzopen/b2cmall_evea/getModelExplainBaseData`, // $ 获取机型解读模块基础信息
  productDetailSearchWord: `${host}/zzopen/hypermall/productDetailSearchWord`,
  leaseJumpUrl: `${host}/zzopen/leaseplatform/query-jump-url`, // $ 获取租赁入口链接
  getInfoDetailBubbleSceneConfigInfo: `${host}/zzopen/waresshow/getInfoDetailBubbleSceneConfigInfo`, // 获取气泡场景配置【透传平台接口】
  getInfoDetailBubbleShowInfo: `${host}/zzopen/waresshow/getInfoDetailBubbleShowInfo`, // 获取收藏气泡信息【透传平台接口】
  getQuestionnaire: `${host}/zzopen/hypermall/getQuestionnaire`, // $ 获取是否展示问卷入口
  addQuestionnaireShowData: `${host}/zzopen/hypermall/addQuestionnaireShowData`, // $ 告知后端已曝光
  productDetailEvalInfo: `${host}/zzopen/b2cmall_evea/productDetailEvalInfo`, // $ 转转商品详情评价相关
  receiveRedBatch: `${host}/zz/transfer/receiveRedBatch`, // 自动领券
  couponInfo: `${host}/zzopen/waresshow/couponInfo` // 获取优惠券信息
}

//app.zhuanzhuan.com/zzopen/hypermall/receiveCoupon
//获取商品基本信息

interface BaseParams {
  infoId?: string
  metric?: string
}
interface BaseInfoParams extends BaseParams {
  orderId?: string
  plat: string
  rstmark: number
  requestType: string
  addressId?: string
  dsPageFlag?: string
  version?: string
  t?: string
  ip?: string
  proId?: string
  cityId?: string
  disId?: string
  uid?: string
  initFrom?: string
  packageId?: string
}
interface MoreInfoParams extends BaseParams {
  orderId?: string
  searchFrom: string
  requestType: string
  quickStart?: string
  version?: string
  t?: string
  ip?: string
  proId?: string
  cityId?: string
  disId?: string
  uid?: string
  packageId?: string
}

// 获取气泡场景配置
export const getInfoDetailBubbleSceneConfigInfo = (params = {}) => {
  return Fetch.get({
    url: API.getInfoDetailBubbleSceneConfigInfo,
    params: {
      ...params
    },
    opts: {
      csrfToken: false
    }
  })
}

// 获取收藏气泡信息
export const getInfoDetailBubbleShowInfo = (params) => {
  return Fetch.get({
    url: API.getInfoDetailBubbleShowInfo,
    params: {
      ...params
    },
    opts: {
      csrfToken: false
    }
  })
}

// 用户触达接入OCD
export const touchInfoByOcd = (params) => {
  return Fetch.get({
    url: API.touchInfoByOcd,
    params: {
      ...params
    },
    opts: {
      csrfToken: false
    }
  })
}

// 用户触达
export const touchInfo = (params) => {
  return Fetch.get({
    url: API.touchInfo,
    params: {
      ...params
    },
    opts: {
      // 不使用csrf机制，促进接口性能提升。增加了csrf机制后，会让接口请求增加一个option请求，到时性能下降。
      csrfToken: false
    }
  })
}

export const transmitParamSearch = (params) => {
  return Fetch.post({
    url: API.transmitParamSearch,
    params: {
      ...params
    }
  })
}

export const getGoodInfo = (params: BaseInfoParams): Promise<BaseInfoType> => {
  return Fetch.get({
    url: API.goodsInfo,
    params: {
      ...params
    },
    opts: {
      // 不使用csrf机制，促进接口性能提升。增加了csrf机制后，会让接口请求增加一个option请求，到时性能下降。
      csrfToken: false
    }
  })
}

//更多信息接口
export const getMoreInfo = (params: MoreInfoParams): Promise<MoreInfoType> => {
  return Fetch.get({
    url: API.goodsMoreInfo,
    params: {
      ...params
    },
    opts: {
      // 不使用csrf机制，促进接口性能提升。增加了csrf机制后，会让接口请求增加一个option请求，到时性能下降。
      csrfToken: false
    }
  })
}

//领红包接口
export const getRedPack = (params: { planId: string }): Promise<any> => {
  return Fetch.get({
    url: API.goodsRedPack,
    params: {
      ...params
    }
  })
}
/**
 * $ 取消收藏
 */
export const getDelLoveInfo = (params: BaseParams): Promise<any> => {
  return Fetch.get({
    url: API.delLoveInfo,
    params: {
      ...params
    }
  })
}

/**
 * $ 收藏
 */
export const getAddLoveInfo = (params: BaseParams): Promise<any> => {
  return Fetch.get({
    url: API.addLoveInfo,
    params: {
      ...params
    }
  })
}

/**
 * $ 加入购物车 接口 https://zapi.zhuanspirit.com/project/7973/interface/api/4074371
 */
interface ICardInfo {
  infoId: string
  infoNum?: string
  metric: string // 订单需要用这个参数来统计商品来源，会影响数据统计
  cartAppType?: string | number // 不传根据 t 值路由 0：转转 1：采货侠 2：找靓机 3：采货侠新一口价卖场 4：线下门店 5：图书内购
}

export const getAddIntoCartFromInfoDetail = (params: ICardInfo): Promise<any> => {
  return Fetch.get({
    url: API.addIntoCartFromInfoDetail,
    params: {
      ...params
    }
  })
}

//商品推荐接口
export const getListData = (params: { param: string }): Promise<any> => {
  return Fetch.post({
    url: API.goodsList,

    params: {
      ...params
    }
  })
}

//获取挂件信息
export const getWidget = (): Promise<any> => {
  return Fetch.get({
    url: API.widget
  })
}
//获取同款推荐
export const getSimilarProducts = (params: BaseParams): Promise<any> => {
  return Fetch.get({
    url: API.similarProducts,
    params: {
      ...params
    }
  })
}

// $ 查询商品同款评价统计信息
export const sameModelEvaluateStatistics = (params: BaseParams): Promise<any> => {
  return Fetch.get({
    url: API.sameModelEvaluateStatistics,
    params: {
      ...params
    }
  })
}

// $ 获取同款评价列表(前两项)
export const orderEvaluatePage = (params: { queryReqDTO: string }): Promise<any> => {
  return Fetch.get({
    url: API.orderEvaluatePage,
    params: {
      ...params
    }
  })
}

// $ 获取帮助信息
export const getQcHelpfulCount = (params: { queryReqDTO: string }): Promise<any> => {
  return Fetch.get({
    url: API.getQcHelpfulCount,
    params: {
      ...params
    }
  })
}

interface IFeedBackInfo {
  qcCode: string | number
  firstItemId: string | number
  secondItemId: string | number
  thirdItemId: string | number
  channelId?: string | number
}

// $ 增加有帮助数值
export const incrQcHelpfulCount = (params: IFeedBackInfo): Promise<any> => {
  return Fetch.post({
    url: API.incrQcHelpfulCount,
    params: {
      ...params
    }
  })
}

// $ 获取质检项的反馈项信息
export const getQcItemFeedbackInfo = (params: IFeedBackInfo): Promise<any> => {
  return Fetch.post({
    url: API.getQcItemFeedbackInfo,
    params: {
      ...params
    }
  })
}

interface ISubmitFeedBack {
  qcCode: string | number
  firstItemId: string | number
  secondItemId: string | number
  thirdItemId: string | number
  channelId: string | number
  optionId: string | number
  feedbackContent: string
}
// $ 提交质检项反馈
export const submitQcItemFeedback = (params: ISubmitFeedBack): Promise<any> => {
  return Fetch.post({
    url: API.submitQcItemFeedback,
    params: {
      ...params
    }
  })
}

/**
 * 将日志打到 https://grafana.zhuanspirit.com/d/iVHxyW8nz/node_fe_count_monitor
 * @param name 某个集群的日志ID（其将自动显示在grafana平台，不用提前注册）
 * @param help 某个集群日志ID的描述
 * @returns
 */
export const prerenderMonitor = (name, help?) => {
  try {
    const app = getAppType()
    // 当应用程序运行在找靓机APP时，才进行上报，使用pc进行调试时则不上报
    if (app === 'zz') {
      const sys = getSysType()
      // https://m.zhuanzhuan.com/zlj/mall_detail  --> mall_detail
      const cluster = location.href.split('/')[4] // 集群标记
      const _name = `${cluster}_${app}_${sys}_${name}`
      const _help = help || _name
      const params = { name: _name, help: _help }

      return Fetch.get({
        url: 'https://fezzmonitor.zhuanzhuan.com/prometheusMonitor',
        params
      })
    }
  } catch (e) {
    console.warn('[prerenderMonitor] 调用prerenderMonitor时报错', e)
  }
}

// $ 获取种草秀信息
export const getZcShowList = (params): Promise<any> => {
  return Fetch.post({
    url: API.zcShowList,
    params: {
      ...params
    }
  })
}

// $ 商详点击立即购买或者以旧换新拉起半弹窗
export const getCostPerformanceUserGiveUpVo = (params: { infoId: string }): Promise<any> => {
  return Fetch.get({
    url: API.getCostPerformanceUserGiveUpVo,
    params: {
      ...params
    }
  })
}

interface IModelExplainBaseData {
  infoId: string
  platType: string
}
// $ 获取机型解读模块基础信息
export const getModelExplainBaseData = (params: IModelExplainBaseData): Promise<any> => {
  return Fetch.get({
    url: API.getModelExplainBaseData,
    params: {
      ...params
    }
  })
}

// productDetailSearchWord 搜索框关键词
export const getProductDetailSearchWord = (params): Promise<any> => {
  return Fetch.get({
    url: API.productDetailSearchWord,
    // url: 'https://zapi.zhuanspirit.com/mock/7713/zzopen/hypermall/productDetailSearchWord',
    params: {
      ...params
    }
  })
}

// $ 获取租赁入口链接
export const getLeaseJumpUrl = (params): Promise<any> => {
  return Fetch.post({
    url: API.leaseJumpUrl,
    params: {
      ...params
    }
  })
}

export const getShowFeedback = (params): Promise<any> => {
  return Fetch.post({
    url: API.getQuestionnaire,
    params: {
      ...params
    },
    opts: {
      format: 'application/json'
    }
  })
}

export const exposureFeedback = (params): Promise<any> => {
  return Fetch.post({
    url: API.addQuestionnaireShowData,
    params: {
      ...params
    },
    opts: {
      format: 'application/json'
    }
  })
}

/**
 * $ 转转商品详情评价相关
 */
export const getProductDetailEvalInfo = (params): Promise<any> => {
  return Fetch.get({
    url: API.productDetailEvalInfo,
    params: {
      ...params
    }
  })
}
// 自动领券中台接口
export const getReceiveRedBatch = (params) => {
  return Fetch.post({
    url: API.receiveRedBatch,
    params: {
      ...params
    }
  })
}
// 获取红包接口
export const getCouponInfo = (params) => {
  return Fetch.get({
    url: API.couponInfo,
    params: {
      ...params
    }
  })
}
